import { RadioCheckedIcon, RadioUncheckedIcon } from "common/assets/icons";
import { useElements } from "domain/pages/ElementPage";
import React from "react";
import { NavLink } from "react-router-dom";
import { KurssloeyfeElementIcon } from "./KurssloeyfeElementIcon";
import styles from "./KurssloeyfeElementNavList.module.css";

interface Props {
  onElementClick?: () => void | undefined;
}

// TODO: Determine how to make sidebar expandable after collapsing
export const KurssloeyfeElementNavList: React.FC<
  React.PropsWithChildren<Props>
> = ({ onElementClick }) => {
  const { elements, buildElementUrl, containerType } = useElements();
  const isSelfAssessment = containerType === "SelfAssessment";

  return (
    <nav className={styles.container}>
      {elements.map((it) => (
        <NavLink
          onClick={onElementClick}
          key={isSelfAssessment ? it.id : it.contentId}
          className={({ isActive }) =>
            `${styles.navLink} ${isActive ? styles.navActive : ""}`
          }
          to={buildElementUrl(it)}
        >
          <KurssloeyfeElementIcon elementType={it.__typename} />
          <span className={styles.linkText}>{it.title}</span>
          {it.canCreateProgression && (
            <span style={{ width: "1rem", marginLeft: "auto" }}>
              {it.finished ? (
                <RadioCheckedIcon altText={`Du har fullført ${it.title}`} />
              ) : (
                <RadioUncheckedIcon
                  altText={`Du har ikke fullført ${it.title}`}
                />
              )}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  );
};
